import { Directive, HostListener } from '@angular/core';
import { Debounce } from 'src/app/shared/directives/debounce/debounce';

@Directive({
  selector: '[debounceKeyup]',
  standalone: false
})
export class DebounceKeyupDirective extends Debounce {
  @HostListener('keyup', ['$event'])
  keyupEvent(event) {
    event.preventDefault();
    event.stopPropagation();
    this.textChangedSubject.next(event);
  }
}
